import { TEAM_MEMBER_PERMISSIONS } from "../constants";
import { UserPermission } from "./types";

const rejectDeleted = (userPermissions?: UserPermission[]) =>
  (userPermissions ?? []).flatMap((up) => (up.deleted_at ? [] : [up]));

export const hasAdminAccess = (userPermissions?: UserPermission[]) =>
  rejectDeleted(userPermissions).some(
    (userPermission) =>
      userPermission.permission.code ===
      TEAM_MEMBER_PERMISSIONS.admin_organization_access,
  );

export const hasConsultationAccess = (userPermissions?: UserPermission[]) =>
  rejectDeleted(userPermissions).some(
    (userPermission) =>
      userPermission.permission.code ===
      TEAM_MEMBER_PERMISSIONS.consultation_access,
  );

export const hasConsultationAccessOnly = (userPermissions: UserPermission[]) =>
  rejectDeleted(userPermissions).every(
    (userPermission) =>
      userPermission.permission.code ===
      TEAM_MEMBER_PERMISSIONS.consultation_access,
  );

export const hasGeneralAccess = (userPermissions?: UserPermission[]) =>
  rejectDeleted(userPermissions).some(
    (userPermission) =>
      userPermission.permission.code === TEAM_MEMBER_PERMISSIONS.general_access,
  );

export const hasFullAccess = (userPermissions?: UserPermission[]) =>
  [
    TEAM_MEMBER_PERMISSIONS.general_access,
    TEAM_MEMBER_PERMISSIONS.consultation_access,
  ].every((permission) =>
    rejectDeleted(userPermissions).some(
      (userPermission) => permission === userPermission.permission.code,
    ),
  );
